import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getNavForRole } from './navConfig';

const linkClass = ({ isActive }) => `nav-link${isActive ? ' active' : ''}`;

function AppSidebar({ sidebar }) {
  const { auth } = useAuth();

  if (!auth) return null;

  const items = getNavForRole(auth.role, auth.companyId);

  return (
    <nav className={`${sidebar} ivs-sidebar`} id="sidebar">
      <ul className="nav">
        {items.map((item) =>
          item.children ? (
            <li className="nav-item" key={item.key}>
              <a
                className="nav-link"
                data-toggle="collapse"
                href={`#${item.key}`}
                aria-expanded="false"
                aria-controls={item.key}
              >
                <i className={`bi ${item.icon} sub-menu`}></i>
                <span className="menu-title">{item.label}</span>
                <i className="menu-arrow"></i>
              </a>
              <div className="collapse" id={item.key}>
                <ul className="nav flex-column sub-menu">
                  {item.children.map((child) => (
                    <li className="nav-item" key={child.to}>
                      <NavLink className={linkClass} to={child.to}>
                        <i className={`bi ${child.icon} sub-menu`}></i>
                        <span className="menu-title">{child.label}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ) : (
            <li className="nav-item" key={item.to}>
              <NavLink className={linkClass} to={item.to}>
                <i className={`bi ${item.icon} menu-icon`}></i>
                <span className="menu-title">{item.label}</span>
              </NavLink>
            </li>
          )
        )}
      </ul>
    </nav>
  );
}

export default AppSidebar;
